import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './hook/Auth'
// import { useSelector } from 'react-redux'

export const ProtectedRoute = ({children}) => {
    // const { user } = useSelector((state) => state.auth)
    const { user } = useAuth();
    if (!user) {
        return <Navigate to="/login" />
    }
    return children
}
